import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Avatar,
    Rating,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import { useTranslation } from "@/hooks/useTranslation";
import { colors } from "@/theme/web-theme";

// Sample customer testimonials with avatars
const testimonials = [
    {
        id: 1,
        name: "Điền Thi Thu Hương",
        avatar: "/assets/croped-user-1.jpg",
        rating: 5,
        comment: "EMBOX đã thay đổi cách tôi tiết kiệm tiền hoàn toàn! Mỗi ngày rút một thẻ và tiết kiệm theo số tiền đó khiến việc tiết kiệm trở nên thú vị như một trò chơi. Mỗi ngày 3 túi mù, sau 1 tháng, tôi đã tiết kiệm được hơn 5 triệu đồng mà không hề cảm thấy áp lực.",
        position: "Nhân viên văn phòng"
    },
    {
        id: 2,
        name: "Hà Quyết Thắng ",
        avatar: "/assets/croped-user-2.jpg",
        rating: 5,
        comment: "Tôi mua EMBOX để dạy con trai 10 tuổi về giá trị của tiền. Mỗi tối, chúng tôi cùng nhau rút một thẻ và con tôi sẽ bỏ tiền tiết kiệm vào heo đất. Giờ đây, con hiểu được việc dành dụm từng ngày sẽ tạo nên khoản tiền lớn sau này.",
        position: "Kỹ sư phần mềm, bố của bé 10 tuổi"
    },
    {
        id: 3,
        name: "Kim Ngân",
        avatar: "/assets/croped-user-3.jpg",
        rating: 4,
        comment: "EMBOX phiên bản 100 rất phù hợp với sinh viên như tôi. Những khoản tiền nhỏ mỗi ngày không làm ảnh hưởng nhiều đến chi tiêu, Tôi và bạn cùng phòng thực hiện cùng nhau, háo hức mỗi ngày, vừa vui mà lại tiết kiệm được tiền, mục tiêu của tôi là 1 chiếc laptop mới",
        position: "Sinh viên năm 4"
    },
    {
        id: 4,
        name: "Phạm Văn Hải",
        avatar: "/assets/croped-user-4.jpg",
        rating: 5,
        comment: "Tôi và bạn gái dùng EMBOX 100 như một thử thách chung. Mỗi ngày chúng tôi cùng nhau rút thẻ và bỏ tiền vào hộp tiết kiệm. Mục tiêu của chúng tôi là chính phục 2 hộp EMBOX 100, để có đủ tiền cho chuyến du lịch Đà Nẵng ",
        position: "Nhân viên nhà nước"
    },
    {
        id: 5,
        name: "Phạm Thùy Dung",
        avatar: "/assets/croped-user-5.jpg",
        rating: 5,
        comment: "Ban đầu tôi nghĩ đây chỉ là một món đồ chơi, nhưng EMBOX thực sự hiệu quả! Cảm giác hồi hộp khi rút thẻ mỗi ngày và niềm vui khi thấy số tiền tiết kiệm tăng lên đã giúp tôi duy trì thói quen tiết kiệm. EMBOX thực sự rất hiệu quả với những người thường xuyên bị cuốn vào việc mua hàng online như tôi.",
        position: "Chủ tiệm nail"
    },
    {
        id: 6,
        name: "Vũ Thị Nga",
        avatar: "/assets/croped-user-6.jpg",
        rating: 4,
        comment: "Tôi mua EMBOX cho cả gia đình cùng tham gia. Đây là cách tuyệt vời để dạy các con về tài chính từ nhỏ. Giờ đây, thay vì đòi mua đồ chơi, chúng đã biết đặt mục tiêu và tiết kiệm để mua những món đồ chúng thực sự muốn.",
        position: "Trưởng phòng Marketing, mẹ của 2 bé"
    }
];

const Testimonials = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isMedium = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            sx={{ py: 8 }}
        >
            <Container>
                <Typography
                    variant="h4"
                    component="h2"
                    align="center"
                    sx={{
                        fontWeight: 700,
                        mb: 6,
                        color: colors.secondary.main,
                    }}
                >
                    {t("home.testimonials")}
                </Typography>

                <Grid container spacing={4}>
                    {testimonials.map((testimonial) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={testimonial.id}
                        >
                            <Card
                                elevation={2}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.3s ease-in-out',
                                    '&:hover': {
                                        transform: 'translateY(-8px)',
                                        boxShadow: '0 12px 20px rgba(0,0,0,0.1)',
                                    },
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1 }}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            mb: 2,
                                        }}
                                    >
                                        <Avatar
                                            src={testimonial.avatar}
                                            alt={testimonial.name}
                                            sx={{ 
                                                width: 64, 
                                                height: 64,
                                                border: `2px solid ${colors.primary.main}`,
                                                mr: 2
                                            }}
                                        />
                                        <Box>
                                            <Typography variant="h6" component="h3" sx={{ fontWeight: 600 }}>
                                                {testimonial.name}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {testimonial.position}
                                            </Typography>
                                            <Rating
                                                value={testimonial.rating}
                                                readOnly
                                                size="small"
                                                sx={{ color: colors.primary.main, mt: 0.5 }}
                                            />
                                        </Box>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>
                                        "{testimonial.comment}"
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Testimonials; 